export default "__VITE_ASSET__DmNDIU_q__"